import { apiPatch, apiPost } from "./utils";

type MessagingDays = Record<string, boolean>;

export const workspacesApi = {
  update: async (attributes: { messagingDays: MessagingDays }) => {
    return apiPatch("/api/v1/workspace", attributes);
  },
  toggleMessagingActive: async (messagingActive: boolean) => {
    return apiPatch("/api/v1/workspace", { messagingActive });
  },
  triggerInitialPull: async () => {
    return apiPost("/api/v1/workspace/trigger_initial_pull", {});
  },
};
